import * as func from './func';

export default func;